// extracted by mini-css-extract-plugin
export default {"customІelect":"styles_customІelect__gjn26","container":"styles_container__uwZSZ","label":"styles_label__on9gp","require":"styles_require__X-HxG","input":"styles_input__gfCrU"};